// src/services/eventTypes.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

/**
 * Event Types API (the eventtypes collection in djr-be).
 *
 *   GET /event-types/public  - no auth: active AND public rows,
 *                              { items: [{ _id, value, label, group }] }
 *   GET /event-types/admin   - admin JWT: every row incl. inactive and
 *                              non-public, all fields, { items: [...] }
 *
 * Both lists come back sorted by displayOrder, then label. Callers render them
 * in that order and must tolerate the query being undefined (loading) or in
 * error (BE down): the booking form falls back to a static list.
 *
 * Based at the API ROOT like serviceCatalog.js, with the full relative path in
 * each query.
 */
const eventTypesApi = createApi({
  reducerPath: "eventTypes",
  baseQuery: prepareBaseQuery(""),
  tagTypes: ["EventType"],
  endpoints: (builder) => ({
    // Public booking form dropdown (no auth).
    getPublicEventTypes: builder.query({
      query: () => ({ url: "event-types/public", method: "GET" }),
      providesTags: ["EventType"],
      keepUnusedDataFor: 3600,
    }),

    // Admin event form: full list including inactive and non-public rows.
    getAdminEventTypes: builder.query({
      query: () => ({ url: "event-types/admin", method: "GET" }),
      providesTags: ["EventType"],
    }),
  }),
});

export const { useGetPublicEventTypesQuery, useGetAdminEventTypesQuery } =
  eventTypesApi;

export default eventTypesApi;
export { eventTypesApi };
